import { render, staticRenderFns } from "./Empresariales.vue?vue&type=template&id=6fee8cc7&scoped=true"
import script from "./Empresariales.vue?vue&type=script&lang=js"
export * from "./Empresariales.vue?vue&type=script&lang=js"
import style0 from "./Empresariales.vue?vue&type=style&index=0&id=6fee8cc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee8cc7",
  null
  
)

export default component.exports